import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AlertMessage from "../../../components/shared/alertMessage/AlertMessage";
import {
  mailbody,
  mailbodyAcceptance,
  mailbodyForInf,
} from "../../../utils/common";
import styles from "./BookInfluencer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { confirmMail } from "../../../services/auth-service/requestService";
import moment from "moment";
import { UserContext } from "../../../App";
import { GetClient_Info } from "../../../services/auth-service/clientAccountService";
import { getInfluencerDetails } from "../../../services/auth-service/InflAccountService";
import { STATUS_TYPE, useDemoSession } from "../../../hooks/demoSession";
import { useSearchParams } from "react-router-dom";
const CheckAvailabilty = () => {
  const { id } = useParams();
  const { state } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [alertData, setAlertData] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [slotsPerPage] = useState(10);
  const [purpose, setPurpose] = useState("");
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false); // New state for action loading
  const [sessionType, setSessionType] = useState("Single");
  const [isActiveButton1, setIsActiveButton1] = useState(false);
  const [isActiveButton2, setIsActiveButton2] = useState(true);
  const [isActiveButton3, setIsActiveButton3] = useState(false); // For demo tab
  const [searchParams, setSearchParams] = useSearchParams();
  const [clientData, setClientData] = useState(null);
  const [influencerData, setInfluencerData] = useState(null);
  const {
    requestDemoSession,
    allowed,
    demoStatus,
    loading: demoLoading,
  } = useDemoSession(influencerData?._id, clientData?._id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const influencerResponse = await getInfluencerDetails(id);
        if (
          influencerResponse.verifyFacebook ||
          influencerResponse.verifyInstagram ||
          influencerResponse.verifyTwitter ||
          influencerResponse.verifyYoutube
        ) {
          setInfluencerData(influencerResponse);
        } else {
          navigate("/notfound");
        }
        if (state) {
          // Fetch client data if state exists
          const clientResponse = await GetClient_Info();
          setClientData(clientResponse.data);
        }
      } catch (error) {
        console.error("Error fetching client or influencer data:", error);
      }
    };
    fetchData();
  }, [state, id, navigate]);

  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        const influencerId = state && influencerData ? influencerData._id : id;
        // For demo sessions, fetch single session slots (demo is always 1-1)
        const fetchType = sessionType === "Group" ? "Group" : "Single";
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/influencertimeslot?influencerId=${influencerId}&type=${fetchType}`,
        );
        const sortedSlots = response.data.sort((a, b) => {
          const dateComparison = new Date(a.date) - new Date(b.date);
          if (dateComparison === 0) {
            return a.startTime < b.startTime
              ? -1
              : a.startTime > b.startTime
                ? 1
                : 0;
          }
          return dateComparison;
        });
        const OneDayFromNow = new Date(Date.now());
        const filteredSlots = sortedSlots.filter((slot) => {
          const dateOnly = slot.date.split("T")[0];
          const currentNewTime = `${dateOnly}T${slot.startTime}:00`;
          return new Date(currentNewTime) > OneDayFromNow;
        });
        setTimeSlots(filteredSlots);
      } catch (error) {
        console.error("Error fetching time slots:", error);
      }
    };
    fetchTimeSlots();
  }, [state, id, influencerData, sessionType]);
  useEffect(() => {
    const tab = searchParams.get("tab");

    if (!tab) {
      // default tab
      setSearchParams({ tab: "single" });
      return;
    }

    if (tab === "group") {
      setSessionType("Group");
      setIsActiveButton1(true);
      setIsActiveButton2(false);
      setIsActiveButton3(false);
    }

    if (tab === "single") {
      setSessionType("Single");
      setIsActiveButton2(true);
      setIsActiveButton1(false);
      setIsActiveButton3(false);
    }

    if (tab === "demo") {
      setSessionType("Single"); // demo uses single slot
      setIsActiveButton3(true);
      setIsActiveButton1(false);
      setIsActiveButton2(false);
    }

    resetStates();
  }, [searchParams]);
  const toggleClassButton1 = () => {
    setSessionType("Group");
    setIsActiveButton1(true);
    setIsActiveButton2(false);
    setIsActiveButton3(false);
    setSearchParams({ tab: "group" });
    resetStates();
  };

  const toggleClassButton2 = () => {
    setSessionType("Single");
    setIsActiveButton2(true);
    setIsActiveButton1(false);
    setIsActiveButton3(false);
    setSearchParams({ tab: "single" });

    resetStates();
  };

  const toggleClassButton3 = () => {
    setSessionType("Single"); // Demo uses single session slots
    setIsActiveButton3(true);
    setIsActiveButton1(false);
    setIsActiveButton2(false);
    setSearchParams({ tab: "demo" });
    resetStates();
  };

  // Function to reset relevant states
  const resetStates = () => {
    setSelectedSlot(null);
    setPurpose("");
    setCurrentPage(1);
  };

  const handleSlotSelect = (slot) => {
    if (!state) {
      navigate("/signin", { state: { from: location }, replace: true });
    } else {
      if (!clientData) {
        setAlertData({
          message: `Sorry, you can't book a session with an influencer sign in. Please sign in as a user.`,
          type: "error",
        });
        return;
      }
      setSelectedSlot(slot);
    }
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(timeSlots.length / slotsPerPage)),
    );
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const renderPageButtons = () => {
    const totalPages = Math.ceil(timeSlots.length / slotsPerPage);
    const buttons = [];

    const renderEllipsis = (id) => (
      <span key={`ellipsis-${id}`} className="ml-2 mt-2">
        ...
      </span>
    );

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || Math.abs(i - currentPage) <= 1) {
        buttons.push(
          <button
            className={`btn btn-outline-primary mt-2 ml-2 ${i === currentPage ? "active" : ""}`}
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={i === currentPage || actionLoading}
          >
            {i}
          </button>,
        );
      } else if (buttons[buttons.length - 1] !== renderEllipsis()) {
        buttons.push(renderEllipsis(i));
      }
    }

    return buttons;
  };

  const handleInputChange = (e) => setPurpose(e.target.value);

  const handleProceedToPayment = async () => {
    setActionLoading(true);
    try {
      const {
        data: { key },
      } = await axios.get(`${process.env.REACT_APP_API_URL}/api/getkey`);
      const {
        data: { order },
      } = await axios.post(`${process.env.REACT_APP_API_URL}/api/checkout`, {
        amount: totalAmount,
      });

      const options = {
        key,
        amount: order.amount,
        currency: "INR",
        name: "Inkorero",
        description: "Transaction for Influencer",
        image: "img/Social-56.png",
        order_id: order.id,
        handler: async function (response) {
          try {
            const mailAcceptance = mailbodyAcceptance({
              razorpay_order_id: response.razorpay_order_id,
            });
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/paymentverification`,
              {
                InfluencerId: influencerData._id,
                clientId: clientData._id,
                selectedSlot,
                slotid: selectedSlot._id,
                amount: totalAmount,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                mailAcceptance,
                purpose,
                platformfee: platformfee,
              },
            );
            setLoading(true);
            if (res.status === 201) {
              const email = clientData.email;
              const receivedData = mailbody(
                res.data.request,
                amountfee,
                gstRate,
                platformfee,
                RazorpayCharge,
              );
              const receivedDataInf = mailbodyForInf(
                res.data.request,
                amountfee,
                gstRate,
                platformfee,
                RazorpayCharge,
              );
              await confirmMail({ ...receivedData, email });
              await confirmMail({
                ...receivedDataInf,
                email: influencerData.email,
              });
              setLoading(false);
              navigate("/makepayment");
            } else {
              throw new Error("Client data does not meet specific condition");
            }
          } catch (error) {
            console.error("Error in handler axios.post:", error);
            setAlertData({
              message: "Payment verification failed. Please try again.",
              type: "error",
            });
          } finally {
            setActionLoading(false);
          }
        },
        modal: {
          ondismiss: function () {
            setActionLoading(false);
          },
        },
        prefill: {
          name: `${clientData.firstName} ${clientData.lastName}`,
          email: `${clientData.email}`,
          contact: `${clientData.phone}`,
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#FE2C55",
        },
      };

      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      console.error("Error creating request:", error);
      setAlertData({
        message: "Failed to initiate payment. Please try again.",
        type: "error",
      });
      setActionLoading(false);
    }
  };

  const handleRequestDemo = async () => {
    if (!selectedSlot) {
      setAlertData({
        message: "Please select a time slot for the demo session",
        type: "warning",
      });
      return;
    }

    if (!purpose || purpose.length < 50) {
      setAlertData({
        message:
          "Please provide a purpose for the demo session (minimum 50 characters)",
        type: "warning",
      });
      return;
    }

    if (!allowed) {
      setAlertData({
        message: `Cannot request demo. Current status: ${demoStatus}`,
        type: "error",
      });
      return;
    }

    setActionLoading(true);
    const result = await requestDemoSession(selectedSlot?._id, purpose);
    if (result?.success) {
      setAlertData({
        message:
          "Demo session requested successfully! Check your email for meeting details.",
        type: "success",
      });
      resetStates();
    } else {
      setAlertData({
        message:
          result?.message ||
          "Failed to request demo session. Please try again.",
        type: "error",
      });
    }
    setActionLoading(false);
  };

  if (loading || demoLoading || actionLoading) {
    return (
      <div className="spinner-container">
        <FontAwesomeIcon className="spinner" icon={faSpinner} />
      </div>
    );
  }

  let amountfee;
  if (sessionType === "Single") {
    amountfee = influencerData?.amountforhalf || 0;
  } else {
    amountfee = influencerData?.amountforfull || 0;
  }

  const platformfee =
    Math.round(amountfee * (influencerData?.platformfee || 0) * 0.01 * 100) /
    100;
  const gstRate = Math.round((platformfee || 0) * 0.18 * 100) / 100;
  const totalAmount =
    Math.round((amountfee + (platformfee || 0) + gstRate) * 100) / 100;
  const RazorpayCharge = Math.round(((totalAmount * 2.36) / 100) * 100) / 100;

  // Determine if we're in demo mode
  const isDemoMode = isActiveButton3;

  return (
    <>
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h4>
              Book your session with:{" "}
              {influencerData ? (
                <span className="font-weight-bold">
                  {influencerData.firstName} {influencerData.lastName}
                </span>
              ) : (
                <p>Loading...</p>
              )}
            </h4>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <div
              className="list-group inflanar-signin__options d-flex flex-row"
              id="list-tab"
              role="tablist"
            >
              <button
                className={`list-group-item rounded-pill mx-1 ${isActiveButton2 ? "active" : "inactive"}`}
                style={{
                  borderTopWidth: "1px",
                  padding: "1rem 1rem",
                  fontSize: "14px",
                  height: "auto",
                }}
                data-bs-toggle="list"
                name="client"
                value="client"
                role="tab"
                onClick={toggleClassButton2}
                disabled={actionLoading}
              >
                <span>Single Session (1:1)</span>
              </button>
              <button
                className={`list-group-item rounded-pill mx-1 ${isActiveButton1 ? "active" : "inactive"}`}
                style={{
                  borderTopWidth: "1px",
                  padding: "1rem 1rem",
                  fontSize: "14px",
                  height: "auto",
                }}
                data-bs-toggle="list"
                name="Influencer"
                value="Influencer"
                role="tab"
                onClick={toggleClassButton1}
                disabled={actionLoading}
              >
                <span>Group Session</span>
              </button>
              <button
                className={`list-group-item rounded-pill mx-1 ${isActiveButton3 ? "active" : "inactive"}`}
                style={{
                  borderTopWidth: "1px",
                  padding: "1rem 1rem",
                  fontSize: "14px",
                  height: "auto",
                }}
                data-bs-toggle="list"
                name="demo"
                value="demo"
                role="tab"
                onClick={toggleClassButton3}
                disabled={actionLoading}
              >
                <span>Request Demo</span>
              </button>
            </div>
          </div>
        </div>

        {/* Demo Status Message */}
        {isDemoMode && demoStatus && (
          <div
            className={`alert ${allowed ? "alert-info" : "alert-danger"} mt-3 d-flex align-items-center`}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            <span>
              {allowed ? (
                "You are eligible for a free demo session. Select a slot and tell us about your session purpose!"
              ) : (
                <>
                  Demo status: <strong>{demoStatus}</strong>.
                  {demoStatus === STATUS_TYPE.PENDING &&
                    " Your demo request is pending approval."}
                  {demoStatus === STATUS_TYPE.ACCEPTED &&
                    "You have already requested a demo session. Please wait for the influencer to accept your request."}
                  {demoStatus === STATUS_TYPE.COMPLETED &&
                    "You have already completed a demo session with this influencer."}
                </>
              )}
            </span>
          </div>
        )}

        {timeSlots.length > 0 ? (
          <>
            <p className="mb-3 pl-3">
              Select a time slot to proceed with the{" "}
              {isDemoMode ? "demo" : sessionType} session:
            </p>
            <div className="row">
              {timeSlots
                .slice(
                  (currentPage - 1) * slotsPerPage,
                  currentPage * slotsPerPage,
                )
                .map((slot) => (
                  <div key={slot._id} className="col-md-3 mb-3">
                    <div
                      className={`card ${styles.cardslot} ${selectedSlot === slot ? "bg-primary text-white" : ""}`}
                      onClick={() => handleSlotSelect(slot)}
                      style={{
                        cursor: actionLoading ? "not-allowed" : "pointer",
                        opacity: actionLoading ? 0.6 : 1,
                      }}
                    >
                      <div className="card-body">
                        <h5 className="card-title">
                          {slot.startTime} - {slot.endTime}
                        </h5>
                        <h6 className="card-text">
                          {moment(slot.date).format("DD/MM/YYYY")}
                        </h6>
                        {sessionType === "Group" && (
                          <span style={{ fontSize: "70%" }}>
                            Remaining {slot.participants}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {/* Purpose textarea - for both demo and non-demo sessions */}
            {selectedSlot && (
              <div style={{ padding: "16px" }}>
                <textarea
                  className={`mb-1 form-control ${styles.textpurpose}`}
                  id={styles.inp}
                  placeholder={
                    isDemoMode
                      ? "Tell us about yourself and what you'd like to discuss in the demo session (minimum 50 characters)"
                      : "Write name, any one of your social media identities and purpose of session (50-400 words)"
                  }
                  minLength={50}
                  maxLength={400}
                  onChange={handleInputChange}
                  value={purpose}
                  rows={4}
                  disabled={actionLoading}
                />
                <small className="text-muted">
                  {purpose.length}/400 characters{" "}
                  {purpose.length < 50 && `(minimum 50 characters required)`}
                </small>
              </div>
            )}

            {/* Demo info message */}
            {selectedSlot && isDemoMode && purpose && purpose.length >= 50 && (
              <div className="my-3 p-3 bg-light rounded">
                <p className="mb-2">
                  <strong>Demo Session Details:</strong>
                </p>
                <p className="mb-2">
                  Date: {moment(selectedSlot.date).format("DD/MM/YYYY")}
                  <br />
                  Time: {selectedSlot.startTime} - {selectedSlot.endTime}
                </p>
                <p className="mb-2">
                  <strong>Purpose:</strong> {purpose}
                </p>
                <p className="text-success mb-0">
                  ✓ Free session - No payment required
                </p>
              </div>
            )}

            {/* Order Summary - Only for non-demo sessions */}
            {!isDemoMode && purpose && purpose.length >= 50 && (
              <>
                <div
                  className={`container rounded m-3 ${styles.paymentContainer}`}
                >
                  <h5 className="m-0 p-2 rounded bg-light">Order Summary</h5>
                  <table className="table m-0">
                    <tbody className={`${styles.cardslot}`}>
                      <tr>
                        <td>
                          <p>
                            <strong>Influencer Fee </strong>
                            <span style={{ fontSize: "80%" }}>
                              (including GST and Taxes)
                            </span>
                          </p>
                        </td>
                        <td>₹{amountfee}</td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>Platform Fee </strong>
                            <span style={{ fontSize: "80%" }}>
                              (including 2.36% payment gateway charges)
                            </span>
                          </p>
                        </td>
                        <td>₹{platformfee || 0}</td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>GST on Platform Fee</strong>
                            <span style={{ fontSize: "80%" }}>
                              (9% CGST and 9% SGST)
                            </span>
                          </p>
                        </td>
                        <td>₹{gstRate}</td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>Total Amount Payable </strong>
                            <span style={{ fontSize: "80%" }}>
                              (inclusive of all taxes)
                            </span>
                          </p>
                        </td>
                        <td>₹{totalAmount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <span
                  className="pl-3"
                  style={{ fontSize: "80%", color: "grey" }}
                >
                  Payment gateway charges 2.36% amounts to ₹
                  {RazorpayCharge}{" "}
                </span>{" "}
                <br />
                <span
                  className="pl-3"
                  style={{ fontSize: "80%", color: "grey" }}
                >
                  Platform Fee and GST on Platform Fee are non-refundable
                </span>
              </>
            )}

            {/* Action Button */}
            <div className="pl-3">
              {isDemoMode ? (
                <button
                  className="btn btn-success mt-3"
                  onClick={handleRequestDemo}
                  disabled={
                    !selectedSlot ||
                    !purpose ||
                    purpose.length < 50 ||
                    !allowed ||
                    actionLoading
                  }
                >
                  {actionLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Requesting...
                    </>
                  ) : (
                    "Request Free Demo Session"
                  )}
                </button>
              ) : (
                <button
                  className="btn btn-primary mt-3"
                  onClick={handleProceedToPayment}
                  disabled={
                    !selectedSlot ||
                    !purpose ||
                    purpose.length < 50 ||
                    actionLoading
                  }
                >
                  {actionLoading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Processing...
                    </>
                  ) : (
                    "Proceed to Payment"
                  )}
                </button>
              )}
            </div>

            {/* Pagination - Moved to bottom with margin-top */}
            <div className="text-center mt-5 pt-3 border-top">
              <button
                className="btn btn-outline-primary mt-2"
                onClick={handlePrevPage}
                disabled={currentPage === 1 || actionLoading}
              >
                Previous Page
              </button>
              {renderPageButtons()}
              <button
                className="btn btn-outline-primary mt-2 ml-2"
                onClick={handleNextPage}
                disabled={
                  currentPage === Math.ceil(timeSlots.length / slotsPerPage) ||
                  actionLoading
                }
              >
                Next Page
              </button>
            </div>
          </>
        ) : (
          <p className="mt-3">Currently, no slots are available for booking.</p>
        )}

        {alertData && (
          <div className="overlay">
            <AlertMessage
              message={alertData.message}
              type={alertData.type}
              onClose={() => setAlertData(null)}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CheckAvailabilty;
